( function () {
	'use strict';

	let bodyScrollLockCount = 0;
	let bodyScrollLockY = 0;

	function lockBodyScroll() {
		if ( bodyScrollLockCount === 0 ) {
			bodyScrollLockY = window.scrollY;
			document.body.style.position = 'fixed';
			document.body.style.top = '-' + bodyScrollLockY + 'px';
			document.body.style.left = '0';
			document.body.style.right = '0';
			document.body.style.width = '100%';
		}
		bodyScrollLockCount++;
	}

	function unlockBodyScroll() {
		bodyScrollLockCount--;
		if ( bodyScrollLockCount <= 0 ) {
			bodyScrollLockCount = 0;
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.left = '';
			document.body.style.right = '';
			document.body.style.width = '';
			window.scrollTo( 0, bodyScrollLockY );
		}
	}

	function init() {
		document.querySelectorAll( '.b-popup' ).forEach( function ( popup ) {
			const triggerId = popup.dataset.triggerId;
			const mode = popup.dataset.mode; // 'popup' | 'inline'

			if ( ! triggerId ) return;

			const triggers = document.querySelectorAll( '.' + triggerId );
			if ( ! triggers.length ) return;

			triggers.forEach( function ( trigger ) {
				trigger.addEventListener( 'click', function ( e ) {
					e.preventDefault();
					popup.setAttribute( 'aria-hidden', 'false' );

					if ( mode === 'inline' ) {
						popup.scrollIntoView( { behavior: 'smooth', block: 'start' } );
					} else if ( mode === 'popup' ) {
						lockBodyScroll();
					}
				} );
			} );

			if ( mode === 'popup' ) {
				const closeBtn = popup.querySelector( '.b-popup__close' );
				if ( closeBtn ) {
					closeBtn.addEventListener( 'click', function () {
						popup.setAttribute( 'aria-hidden', 'true' );
						unlockBodyScroll();
					} );
				}
			}
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
